module.exports = __webpack_public_path__ + "static/media/packages.020a1d1b.svg";